import React from 'react';
// Components
import BillingTable from 'components/common/BillingTable/BillingTable';

const Billing = (): JSX.Element => {
  return <BillingTable />;
};

export default Billing;
